import {Directive} from '@angular/core';

@Directive({
  selector: '.app-carousel-item'
})
export class CarouselItemElementDirective {

}
